import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { ConfigurationSecurity } from "@/model/data/security/ConfigurationSecurity";

export class ImportTemplateResData extends ApiGenericResponse {
    referenceConfiguration: ConfigurationSecurity;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.ReferenceConfiguration) {
            this.referenceConfiguration = new ConfigurationSecurity();
            this.referenceConfiguration.parse(obj.ReferenceConfiguration);
        }
    }
}
